/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mealy_Trite_Butterfly_DashInputs */

const fr_mealy_trite_butterfly_dash = /** @type {(inputs: Mealy_Trite_Butterfly_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs`)
};

/**

* @param {Mealy_Trite_Butterfly_DashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mealy_trite_butterfly_dash = /** @type {((inputs?: Mealy_Trite_Butterfly_DashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mealy_Trite_Butterfly_DashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mealy_trite_butterfly_dash(inputs)
});